export default __webpack_public_path__ + "static/media/investorSteveJobs.b121591c.wav";